<template>
  <!-- 套餐 -->
  <div class="packageWrap" v-if="goodsList?.length > 0">
    <div class="packageLeft">
      <p class="fs14 fwb">
        {{ getLanguage == "zh" ? goodsList[0].package?.packageNameCn : goodsList[0].package?.packageName }}
      </p>
      <p>
        <span class="fs20 fwb black00">{{ priceCurrencyFormat(goodsList[0].package?.price, goodsList[0].package?.currency) }}</span>
        <span class="fs14 tdlt ml6 fwb blackD8">({{ serviceListPriceSum(goodsList[0].package?.serviceList, goodsList[0].package?.currency) }})</span>
      </p>
      <div class="pt10">
        <!-- 适用人群 -->
        <p class="fs12">{{ $t("creation.crowd") }}</p>
        <p class="fs12 black88">
          {{ getLanguage == "zh" ? goodsList[0].package?.applicablePersonCn : goodsList[0].package?.applicablePerson }}
        </p>
      </div>
    </div>
    <div class="packageRight">
      <div class="fdr details">
        <div class="mr20">
          <!-- 套餐包含： -->
          <p class="fs12 fwb">
            {{ $t("creation.comboInclude") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="child in goodsList[0].package?.serviceList" :key="'child' + child.id">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ getLanguage == "zh" ? child.descriptionCn : child.description }}
              <span v-if="$isNumberLike(child.serviceFee)">({{ priceCurrencyFormat(child.serviceFee, child.currency) }})</span>
              <info-popover
                placement="top"
                :content="getLanguage == 'zh' ? child.serviceScopeCn : child.serviceScope"
                iconClass="ml2 fs13 blackD8"
                v-if="child.serviceScopeCn && child.serviceScope"
              />
            </li>
          </ul>
        </div>
        <!-- 第三方费用 -->
        <div class="mr20">
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            {{ $t("creation.priceInclude") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="subset in mergeSameAttrList(goodsList[0].package?.serviceList, 'thirdPartyFeeDescription', 'thirdPartyFee')" :key="`subset-${subset.id}`">
              <span v-if="getLanguage == 'zh' && subset.thirdPartyFeeDescriptionCn">- {{ subset.thirdPartyFeeDescriptionCn }}</span>
              <span v-if="getLanguage == 'en' && subset.thirdPartyFeeDescription">- {{ subset.thirdPartyFeeDescription }}</span>
              <span v-if="$isNumberLike(subset.thirdPartyFee)">({{ priceCurrencyFormat(subset.thirdPartyFee, subset.currency) }})</span>
            </li>
          </ul>
        </div>
        <!-- 其他费用 -->
        <div>
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            {{ $t("creation.otherExpenses") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="other in mergeSameAttrList(goodsList[0].package?.serviceList, 'otherFeeDescription', 'otherFee')" :key="`other-${other.id}`">
              <span v-if="getLanguage == 'zh' && other.otherFeeDescriptionCn">- {{ other.otherFeeDescriptionCn }}</span>
              <span v-if="getLanguage == 'en' && other.otherFeeDescription">- {{ other.otherFeeDescription }}</span>
              <span v-if="$isNumberLike(other.otherFee)">({{ priceCurrencyFormat(other.otherFee, other.currency) }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatMixin from "@/mixins/formatMixin";
import priceCountMixin from "@/mixins/priceCountMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin, priceCountMixin],
  props: {
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  display: flex;
  width: 100%;
  padding: 16px;
  background-color: #fdf6ec;

  .packageLeft {
    padding-right: 16px;
    max-width: 250px;
  }

  .packageRight {
    padding-left: 16px;
    border-left: 1px solid #e4e7ed;
  }
}
</style>
